import DarkModeIcon from "components/common/icons/darkModeIcon";
import LightModeIcon from "components/common/icons/lightModeIcon";
import { useDispatch, useSelector } from "react-redux";
import { toggleTheme, setTheme } from "store/themeSlice";
import "./themeToggler.scss";
import { useEffect } from "react";
import { updateUserLayoutAPI } from "api/user";

const ThemeToggler = () => {
  const mode = useSelector((state) => state.theme.mode);
  const userOrgType = useSelector((state) => state.auth.user.orgType);
  const dispatch = useDispatch();

  useEffect(() => {
    // Read theme from localStorage on first render
    const storedTheme = JSON.parse(localStorage.getItem("userLayout"))?.theme?.mode;
  
    if (storedTheme) {
      console.log("Applying stored theme:", storedTheme);
      dispatch(setTheme(storedTheme)); // Set Redux state to stored theme
    } else {
      // Default theme logic if no stored theme exists
      const defaultTheme = userOrgType === 2 ? "light" : "dark";
      console.log("Setting default theme:", defaultTheme);
      dispatch(setTheme(defaultTheme));
      updateThemePref(defaultTheme);
    }
  }, [dispatch, userOrgType]); // Run only once on mount

  useEffect(() => {
    // Ensure body reflects the current mode
    document.body.setAttribute("data-theme", mode);
    updateThemePref(mode);
  }, [mode]);

  const updateThemePref = async (themeMode) => {
    const localStorageData = JSON.parse(localStorage.getItem("userLayout")) || {};

    const postBody = {
      layout: JSON.stringify({
        ...localStorageData,
        theme: { mode: themeMode }, // Store updated theme
      }),
    };

    localStorage.setItem("userLayout", postBody.layout);
    await updateUserLayoutAPI(postBody);
  };

  const handleToggle = () => {
    dispatch(toggleTheme());
  };

  return (
    <div className="theme_toggler" onClick={handleToggle}>
      {mode !== "dark" ? <DarkModeIcon /> : <LightModeIcon />}
      {mode !== "dark" ? "Dark Mode" : "Light Mode"}
    </div>
  );
};

export default ThemeToggler;
